<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }

  <mat-select
    #formFieldSelect
    [formControlName]="field"
    [value]="value"
    (selectionChange)="selectionChanged.emit($event)"
    (valueChange)="valueChanged.emit($event)"
    [required]="mandatory"
    [multiple]="multiple"
    >
    @for (o of choices; track o; let i = $index) {
      <mat-option [id]="getOptionId(o, i)" [value]="getOptionValue(o)">
        @if (displayFn) {
          {{ displayFn(o) }}
        }
        @if (displayTemplateRef) {
          <ng-container *ngTemplateOutlet="displayTemplateRef; context: { option: o }"></ng-container>
        }
      </mat-option>
      @if (separatorCondition && separatorCondition(o)) {
        <mat-divider></mat-divider>
      }
    }

    @if (displayTriggerRef) {
      <mat-select-trigger>
        <ng-container *ngTemplateOutlet="displayTriggerRef; context: { option: formGroup.controls[field].value }"></ng-container>
      </mat-select-trigger>
    }
  </mat-select>
  @if (shouldDisplayClearBtn()) {
    <button mat-icon-button matSuffix data-role="clear" (click)="resetControlValue($event)">
      <mat-icon>clear</mat-icon>
    </button>
  }

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of errors; track e) {
      @if (formGroup.controls[field].hasError(e.error)) {
        <span [attr.data-error]="e.error">
          {{ e.messageKey | translate: formGroup.controls[field].getError(e.error) }}
        </span>
      }
    }
  </mat-error>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
